import config from 'constants/config'

const PREFIX_MAP: Record<App.BrandName, string> = {
  luxuryescapes: '',
  lebusinesstraveller: '',
}

export function formatBrazeUserId(memberId: string) {
  // we need to add brand prefix only for white label brands
  const brandPrefix = PREFIX_MAP[config.BRAND]

  return brandPrefix ? `${brandPrefix}_${memberId}` : memberId
}
